import Api from './api';
import { JsonApiResponse, toJsonApiResponse } from 'utils/json-api';
import CaskHistory from 'models/cask-order-history';

export default class CaskOrderHistoryService {
    static async getCaskOrderHistory(caskId: number): Promise<JsonApiResponse<CaskHistory[]>> {
        let response = await Api.get(`casks/${caskId}/history`);
        return await toJsonApiResponse<CaskHistory[]>(response);
    }
}